import Component from '@galactic-advisors/component-loader';
import axios from 'axios';
import { Toast, ToastStatusTypes } from '../../../../../../ts/toast.ts';

const DEFAULTS = {
  previewSelectionBtnElement: '[data-preview-selection-btn]',
  statusInputElement: '[data-status-input]',
  companyInputElement: '[data-company-input]',
  fromAddressElement: '[data-from-address-selector]',
  rowCheckboxSelector: '[data-row-checkbox]',
  afterDateInputElement: '[data-after-date-input]',
  loaderElement: '[data-loader]',
  paginationLinksElement: '[data-pagination-links]',
  tableBodyElement: '[data-table-body]',
  tableContainerElement: '[data-table-container]',
  selectAllCheckboxElement: '[data-select-all]',
  itemFilterInput: '[data-item-filter]',
  sendBtnElement: '[data-send-btn]',
};

export default class TrainingMassEmailAdvancedSelection extends Component {
  static selector = '[data-comp-training-mass-email-adv-selection-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.checkedItems = new Set();

    this.currentPageItems = [];

    this.previewSelectionButton = this.$container.querySelector(
      this.$options.previewSelectionBtnElement,
    );

    this.statusInput = this.$container.querySelector(
      this.$options.statusInputElement,
    );

    this.companyInput = this.$container.querySelector(
      this.$options.companyInputElement,
    );

    this.fromAddress = this.$container.querySelector(
      this.$options.fromAddressElement,
    );

    this.itemFilter = this.$container.querySelector(
      this.$options.itemFilterInput,
    );

    this.afterDateInput = this.$container.querySelector(
      this.$options.afterDateInputElement,
    );

    this.tableBody = this.$container.querySelector(
      this.$options.tableBodyElement,
    );

    this.tableContainer = this.$container.querySelector(
      this.$options.tableContainerElement,
    );

    this.paginationLinks = this.$container.querySelector(
      this.$options.paginationLinksElement,
    );

    this.selectAllCheckbox = this.$container.querySelector(
      this.$options.selectAllCheckboxElement,
    );

    this.loader = this.$container.querySelector(this.$options.loaderElement);

    this.sendButton = this.$container.querySelector(
      this.$options.sendBtnElement,
    );

    this.toast = Toast.instance;

    this.initListeners();
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;
    const itemId = parseInt(checkbox.value, 10);

    if (checkbox.checked) {
      this.checkedItems.add(itemId);
    } else {
      this.checkedItems.delete(itemId);
    }
    this.updateSelectAllCheckbox();
  }

  toggleSelectAll(event) {
    const isChecked = event.target.checked;

    this.tableBody
      .querySelectorAll(this.$options.rowCheckboxSelector)
      .forEach((checkbox) => {
        if (
          checkbox.dataset.status === 'Unstarted' ||
          checkbox.dataset.sentOn === 'null'
        ) {
          checkbox.checked = isChecked;
          const itemId = parseInt(checkbox.value, 10);

          if (isChecked) {
            this.checkedItems.add(itemId);
          } else {
            this.checkedItems.delete(itemId);
          }
        }
      });
  }

  updateSelectAllCheckbox() {
    const allChecked = this.currentPageItems.every((item) => this.checkedItems.has(item.id));
    const someChecked = this.currentPageItems.some((item) => this.checkedItems.has(item.id));

    this.selectAllCheckbox.checked = allChecked;
    this.selectAllCheckbox.indeterminate = !allChecked && someChecked;
  }

  fetchSelection(endpoint, requestData) {
    this.loader.classList.remove('d-none');
    axios
      .get(endpoint, { params: requestData })
      .then((response) => {
        this.loader.classList.add('d-none');
        const { data, links } = response.data;

        const filteredData = ['Unstarted', 'Started'].includes(
          this.statusInput.value,
        )
          ? data.filter((item) => item.status === this.statusInput.value)
          : data;

        this.currentPageItems = filteredData;
        this.hydrateTable(filteredData);
        this.updateSelectAllCheckbox();
        this.hydratePaginatorLinks(endpoint, links);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }

  hydrateTable(responseData) {
    this.tableContainer.classList.remove('d-none');
    this.tableBody.innerHTML = '';
    if (responseData.length <= 0) {
      const row = document.createElement('tr');
      row.classList.add('scrollable-table--body-row');

      row.innerHTML = `
        <td colspan="3" class="text-center scrollable-table-body-row-cell">
            There are no records
        </td>
      `;
      this.tableBody.appendChild(row);
      return;
    }

    responseData.forEach((item) => {
      const row = document.createElement('tr');
      row.classList.add('scrollable-table--body-row');
      row.dataset.rowItem = item.id;
      row.innerHTML = `
            <td class="scrollable-table--body-row-cell">
            <input type="checkbox" data-row-checkbox value="${item.id}" ${
  this.checkedItems.has(item.id) ? 'checked' : ''
} data-status="${item.status}" data-sent-on="${item.sent_on}"></td>
            <td class="scrollable-table--body-row-cell" data-item-name>${
  item.user_name
}</td>
            <td class="scrollable-table--body-row-cell" data-item-email>${
  item.user_email
}</td>
            <td class="scrollable-table--body-row-cell" data-item-company>${
  item.company
}</td>

  <td class="scrollable-table--body-row-cell" data-item-status>${
  item.status
}</td>

 <td class="scrollable-table--body-row-cell" data-item-sent-on>${
  item.sent_on
}</td>
          `;
      this.tableBody.appendChild(row);
    });
    this.tableBody
      .querySelectorAll(this.$options.rowCheckboxSelector)
      .forEach((checkbox) => {
        checkbox.addEventListener('change', (e) => {
          this.handleCheckboxChange(e);
        });
      });
  }

  hydratePaginatorLinks(endpoint, links) {
    this.paginationLinks.innerHTML = links;

    this.paginationLinks.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const url = link.getAttribute('href');
        const urlParams = new URLSearchParams(new URL(url).search);
        const params = Object.fromEntries(urlParams.entries());
        this.fetchSelection(endpoint, params);
      });
    });
  }

  submitRecipients() {
    this.loader.classList.remove('d-none');
    axios
      .post(this.sendButton.dataset.submitRecipientsUrl, {
        from_address: this.fromAddress.value,
        instance_ids: [...this.checkedItems],
      })
      .then((response) => {
        this.loader.classList.add('d-none');
        this.toast.show(ToastStatusTypes.SUCCESS, response.data.message);
        window.location.reload();
      });
  }

  initListeners() {
    this.previewSelectionButton.addEventListener('click', (event) => {
      event.preventDefault();

      const requestData = {
        company_id: this.companyInput.value,
        after_date: this.afterDateInput.value,
        page: 1,
      };
      this.fetchSelection(event.target.dataset.endpoint, requestData);
    });

    this.selectAllCheckbox.addEventListener('change', (e) => {
      this.toggleSelectAll(e);
    });

    this.itemFilter.addEventListener('keyup', (event) => {
      this.currentPageItems.forEach((item) => {
        if (
          item.user_name
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          item.company
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          item.user_email
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        ) {
          this.tableBody.querySelector(`[data-row-item="${item.id}"]`).style.display =
            'flex';
        } else {
          this.tableBody.querySelector(`[data-row-item="${item.id}"]`).style.display =
            'none';
        }
      });
    });

    this.sendButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.checkedItems.size <= 0) {
        alert('You must select at least one recipient.');
        return;
      }

      const confirmation = confirm(
        `Send this training certification to ${this.checkedItems.size} people?`,
      );

      if (confirmation) {
        this.submitRecipients();
      }
    });
  }
}
